import { render, staticRenderFns } from "./CompositeFormSelect.vue?vue&type=template&id=0af58c08&scoped=true&"
import script from "./CompositeFormSelect.vue?vue&type=script&lang=js&"
export * from "./CompositeFormSelect.vue?vue&type=script&lang=js&"
import style0 from "./CompositeFormSelect.vue?vue&type=style&index=0&id=0af58c08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af58c08",
  null
  
)

export default component.exports